var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class AddTaxCode {
  constructor(_data) {
    /**
     */
    __publicField(this, "ClientTaxCode");
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "OutOfScope");
    /**
     */
    __publicField(this, "ReverseCharge");
    /**
     */
    __publicField(this, "TransactionTypeCode");
    /**
     */
    __publicField(this, "TypeOfGoods");
    /**
     */
    __publicField(this, "VatRateType");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof AddTaxCode
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.TaxCode.AddTaxCode");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.ClientTaxCode = _data["ClientTaxCode"];
      this.CountryCode = _data["CountryCode"];
      this.OutOfScope = _data["OutOfScope"];
      this.ReverseCharge = _data["ReverseCharge"];
      this.TransactionTypeCode = _data["TransactionTypeCode"];
      this.TypeOfGoods = _data["TypeOfGoods"];
      this.VatRateType = AddTaxCodeVatRateType[_data["VatRateType"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["ClientTaxCode"] = this.ClientTaxCode;
    _data["CountryCode"] = this.CountryCode;
    _data["OutOfScope"] = this.OutOfScope;
    _data["ReverseCharge"] = this.ReverseCharge;
    _data["TransactionTypeCode"] = this.TransactionTypeCode;
    _data["TypeOfGoods"] = this.TypeOfGoods;
    _data["VatRateType"] = AddTaxCodeVatRateType[this.VatRateType];
    return _data;
  }
}
export var AddTaxCodeVatRateType = /* @__PURE__ */ ((AddTaxCodeVatRateType2) => {
  AddTaxCodeVatRateType2["Standard"] = "Standard";
  AddTaxCodeVatRateType2["Standard2"] = "Standard2";
  AddTaxCodeVatRateType2["Reduced"] = "Reduced";
  AddTaxCodeVatRateType2["SuperReduced"] = "SuperReduced";
  AddTaxCodeVatRateType2["SuperReduced2"] = "SuperReduced2";
  AddTaxCodeVatRateType2["Exempt"] = "Exempt";
  AddTaxCodeVatRateType2["ZeroRated"] = "ZeroRated";
  AddTaxCodeVatRateType2["Middle"] = "Middle";
  AddTaxCodeVatRateType2["Reduced2"] = "Reduced2";
  return AddTaxCodeVatRateType2;
})(AddTaxCodeVatRateType || {});
